<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <h1 class="title-default">Configurações dos Orçamentos</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="voltar()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Configurações que valem para todos os orçamentos.
        </p>
      </div>
    </div>

    @if (isLoading) {
      <div class="section-container">
        <app-loading-box height="30" width="200" marginTop="0"></app-loading-box>
        <app-loading-box height="22" width="55%" marginTop="16"></app-loading-box>
        <app-loading-box height="22" width="48%" marginTop="12"></app-loading-box>
        <app-loading-box height="22" width="52%" marginTop="12"></app-loading-box>
      </div>
      <div class="section-container mt-4">
        <app-loading-box height="30" width="160" marginTop="0"></app-loading-box>
        <app-loading-box height="22" width="45%" marginTop="16"></app-loading-box>
        <app-loading-box height="22" width="55%" marginTop="12"></app-loading-box>
        <app-loading-box height="22" width="50%" marginTop="12"></app-loading-box>
        <app-loading-box height="72" width="100%" marginTop="16"></app-loading-box>
      </div>
      <div class="section-container mt-4">
        <app-loading-box height="30" width="180" marginTop="0"></app-loading-box>
        <app-loading-box height="150" width="100%" marginTop="16"></app-loading-box>
      </div>
      <div class="section-container mt-4">
        <app-loading-box height="30" width="200" marginTop="0"></app-loading-box>
        <app-loading-box height="120" width="100%" marginTop="16"></app-loading-box>
        <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
      </div>
    } @else {
      <form [formGroup]="form">
        <app-page-scroll-spy [sections]="sections"></app-page-scroll-spy>

        <div class="section-container" id="regras-bloqueios">
          <div class="section-title">
            <mat-icon>gavel</mat-icon>
            <span>Regras e bloqueios</span>
          </div>

          <div class="row mt-3 conteudo-secao">
            <div class="col-12">
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="vendedorObrigatorio">Vendedor
                  obrigatório</mat-slide-toggle>
                <span class="info-text">O orçamento só pode ser salvo com um vendedor informado.</span>
              </div>

              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="calcularImpostos">Calcular impostos
                  nos orçamentos</mat-slide-toggle>
                <span class="info-text">Habilita o cálculo automático de tributos na criação do orçamento.</span>
              </div>

              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact"
                  formControlName="isOrcamentoExpiraAutomatico">Orçamentos expiram
                  automaticamente</mat-slide-toggle>
                <span class="info-text">{{ validadeApoio }}</span>
              </div>

              @if (form.get('isOrcamentoExpiraAutomatico')?.value) {
                <div class="bloco-indentado">
                  <mat-form-field appearance="outline" class="campo-prazo">
                    <mat-label>Prazo de validade (dias)</mat-label>
                    <input matInput type="number" class="no-spinner" min="1" step="1" placeholder="Ex.: 15"
                      formControlName="prazoValidadeDias">
                    @if (prazoValidadeInvalido) {
                    <mat-error>Informe um número inteiro maior que zero.</mat-error>
                    }
                  </mat-form-field>
                  @if (!prazoValidadeInvalido) {
                  <div class="hint-text">Informe um número inteiro maior que zero.</div>
                  }

                  <div class="toggle-content mt-3">
                    <mat-slide-toggle class="app-toggle-compact" formControlName="isPrazoValidadeEditavel">Permitir
                      que o vendedor edite este prazo no orçamento</mat-slide-toggle>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>

        <div class="section-container mt-4" id="impressao">
          <div class="section-title">
            <mat-icon>print</mat-icon>
            <span>Impressão</span>
          </div>

          <div class="row mt-3 conteudo-secao">
            <div class="col-12">
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="imprimirNcm">Imprimir NCM dos
                  produtos</mat-slide-toggle>
              </div>

              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="imprimirDescComplementar">Imprimir
                  descrição complementar dos produtos</mat-slide-toggle>
              </div>

              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="imprimirEmailUsuario">Imprimir e-mail
                  do usuário no orçamento</mat-slide-toggle>
              </div>

              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="imprimirImpostosItens">Imprimir
                  impostos dos itens na impressão do orçamento</mat-slide-toggle>
                <span class="info-text">Disponível apenas com o cálculo de impostos ativo.</span>
              </div>

              @if (mostrarImpostos) {
                <div class="bloco-indentado">
                  <app-impostos-impressos-selecao
                    [impostos]="opcoesTipoImpostoImpressao"
                    [value]="impostosSelecionados"
                    (valueChange)="onImpostosChange($event)">
                  </app-impostos-impressos-selecao>
                </div>
              }
            </div>

            <div class="col-12">
              <div class="bloco-separado">
                <label class="bloco-titulo">Imagens dos produtos</label>
                <mat-radio-group formControlName="idTipoImpressaoImagem" class="d-flex flex-column"
                  style="gap: 12px">
                  @for (t of opcoesTipoImpressaoImagem; track t.idTipoImpressaoImagem) {
                  <mat-radio-button [value]="t.idTipoImpressaoImagem">{{ t.descricao }}</mat-radio-button>
                  }
                </mat-radio-group>
              </div>
            </div>
          </div>
        </div>

        <div class="section-container mt-4" id="observacoes">
          <div class="section-title">
            <mat-icon>notes</mat-icon>
            <span>Observações</span>
          </div>

          <div class="row mt-3 conteudo-secao">
            <div class="col-12">
              <label class="bloco-titulo">Observação padrão dos orçamentos</label>
              <div class="editor-container editor-observacao">
                <ngx-editor-menu [editor]="editorObservacao" [toolbar]="toolbar"></ngx-editor-menu>
                <ngx-editor [editor]="editorObservacao" formControlName="observacaoPadrao"
                  placeholder="Escreva as observações...">
                </ngx-editor>
              </div>
            </div>
          </div>
        </div>

        <div class="section-container mt-4" id="textos-padrao">
          <div class="section-title">
            <mat-icon>subject</mat-icon>
            <span>Textos padrão</span>
          </div>

          <div class="row mt-3 conteudo-secao">
            <div class="col-12">
              <div class="hint-text mb-4">{{ textosPadraoApoio }}</div>
            </div>

            <div class="col-12">
              <label class="bloco-titulo">Introdução</label>
              <div class="editor-container editor-introducao">
                <ngx-editor-menu [editor]="editorIntroducao" [toolbar]="toolbar"></ngx-editor-menu>
                <ngx-editor [editor]="editorIntroducao" formControlName="textoIntroducao"
                  placeholder="Texto exibido no início do orçamento...">
                </ngx-editor>
              </div>
              <div class="toggle-content mt-3">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isIntroducaoEditavel">Permitir que o
                  vendedor edite este texto no orçamento</mat-slide-toggle>
              </div>
            </div>

            <div class="col-12">
              <div class="bloco-separado">
                <label class="bloco-titulo">Assinatura</label>
                <div class="row">
                  <div class="col-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Saudação</mat-label>
                      <input matInput formControlName="assinaturaSaudacao" placeholder="Ex.: Atenciosamente,">
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Responsável / setor</mat-label>
                      <input matInput formControlName="assinaturaResponsavel"
                        placeholder="Ex.: Departamento de vendas">
                    </mat-form-field>
                  </div>
                </div>
                <div class="toggle-content">
                  <mat-slide-toggle class="app-toggle-compact" formControlName="isAssinaturaEditavel">Permitir que o
                    vendedor edite estes dados no orçamento</mat-slide-toggle>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    }
  </div>
</div>

<app-footer-action
  [isLoadingSalvar]="isSaving"
  [isSalvarDisabled]="isLoading || !configCarregada"
  (cancelar)="voltar()"
  (salvar)="salvar()">
</app-footer-action>
